<template>
  <b-modal id="cancel-subscription" title="Cancel Subscription" hide-footer>
    <p>We're sorry to see you go. Please let us know why.</p>
      <b-form @submit.prevent="deactivateAccount">
      <b-form-group label-for="reason" required>
        <label class="form-control-label">Reason for Cancellation:</label>
        <b-form-select v-model="form.reason" :options="reasons" required></b-form-select>
      </b-form-group>
      <b-form-group label-for="other_reason" v-if="form.reason == 'Other'">
        <label class="form-control-label">Cancellation Reason:</label>
        <b-form-input v-model="form.other_reason"></b-form-input>
      </b-form-group>
      <b-form-group>
        <b-form-textarea id="cancel-comments" v-model="form.comments" placeholder="Please let us know how we can improve..." rows="3" max-rows="6"></b-form-textarea>
      </b-form-group>
      <b-button block variant="danger" type="submit" :disabled="disabled">
        <span v-if="disabled"><i class="fas fa-circle-notch fa-spin fa-2x"></i></span>
        <span v-else>Cancel Subscription</span>
      </b-button>
    </b-form>
  </b-modal>
</template>

<script>
import axios from 'axios';
import { mapGetters } from 'vuex';
import swal from 'sweetalert2';
import 'sweetalert2/dist/sweetalert2.css';

export default {
  data() {
    return {
      form: {
        user_id: null,
        reason: null,
        other_reason: null,
        comments: '',
      },
      reasons: [
        {value: null, text: "Select a cancellation reason."},
        {value: "Signed up and never used it", text: "Signed up and never used it"},
        {value: "Don’t use it as much as I intended", text: "Don’t use it as much as I intended"},
        {value: "Dislike Product", text: "Dislike Product"},
        {value: "Cutting Costs", text: "Cutting Costs"},
        {value: "Other", text: "Other"}
      ],
      disabled: false,
    }
  },
  computed: {
    ...mapGetters({
      user: 'profile/user',
      userRoute: 'profile/userRoute',
    }),
  },
  methods: {
    async deactivateAccount() {
      this.disabled = true;
      await axios.post(this.userRoute + "/deactivate", this.form)
      .then(response => {
        swal.fire({
          title: `Success`,
          text: response.data,
          showConfirmButton: false,
          timer: 2750,
          icon: 'success'
        })
        .then(result => {
          this.logout();
        });
      })
      .catch(error => {
        this.disabled = false;
      });
    },
    async logout() {
      await axios.post(process.env.VUE_APP_API_BASE_URL + "/logout", {
        email: this.user.email
      })
      .then(response => {
        this.$store.dispatch("logout", {email: this.user.email});
      })
      .catch(error => {
        this.error(error);
      });
    }
  }
};
</script>